<template>
  <base-form :title="$t(`job.details.title`, {jobTitle: form.job.title})"
             :key="renderKey"
             :loading="loading"
             :save-text="saveText"
             @submit="updateJob">
    <div v-if="currentJob.status === 'draft'">
      <div class="col-12">
        <section-separator has-border size="lg" class="mt-2">
          {{$t('job.create.details.payment')}}
        </section-separator>
      </div>

      <div class="col-12">
        <job-create-product ref="step2"
                            :products="jobPostingProducts"
                            :job="form.job"
                            :client="form.job.client"
                            :product="form.product"
                            :multiple-job-boards="false"
                            @product-select="onProductSelect"
                            @job-board-select="onJobBoardSelect"
                            @payment-selected="onPaymentSelected"
                            @segment-change="onSegmentsChange"
                            @client-change="onClientChange"
                            @po_number-change="onPoNumberChange"
                            @contracts-balance="onContractsBalance">
        </job-create-product>
        <section-separator has-border size="lg" class="mt-2">
        </section-separator>
      </div>
    </div>

    <job-create-details ref="step0"
                        class="col-12"
                        :form-saved="formSaved"
                        :client="form.client"
                        :job="form.job"
                        @on-validated="syncJob">
    </job-create-details>

    <job-create-segments :segments="jobSegments"
                         :selected-segments="form.job.segments"
                         :extra-info="form.job"
                         @on-validated="syncSegments"
                         ref="step1">
    </job-create-segments>

    <div>
      <div class="col-12">
        <section-separator has-border size="lg" class="mt-2">
          {{$t('job.create.details.infos')}}
        </section-separator>
      </div>
      <JobInfos class="col-12 w-full"
                v-model="jobInfo"
                :entity="jobInfoEntity"
      />
    </div>
    <div>
      <div class="col-12">
        <section-separator has-border size="lg" class="mt-2">
          {{$t('job.create.details.settings')}}
        </section-separator>
      </div>

      <div class="row">
        <div class="col-12 flex">
          <job-followers class="w-full px-2"
                         :data="form.job.followers"
                         :client="form.job.client"
          />
        </div>
        <div class="col-12 flex">
          <div class="col-6">
            <fg-input :placeholder="$t('job.create.details.status')"
                      :label="$t('job.create.details.status')">
              <el-select v-model="form.job.status" class="select-default">
                <el-option v-for="status in jobStatuses"
                           :label="status"
                           :value="status"
                           :key="status"
                           class="select-default">
                </el-option>
              </el-select>
            </fg-input>
          </div>
          <job-select-job-boards v-if="currentJob.status !== 'draft'"
                                 :form="form"
                                 ref="step3">
          </job-select-job-boards>
        </div>
        <div class="col-12 flex">
          <div class="col-6">
            <fg-input :placeholder="$t('job.create.details.dateOrder')"
                      :label="$t('job.create.details.dateOrder')"
                      :name="$t('job.create.details.dateOrder')"
                      :add-form-control-class="false"
                      component="el-date-picker"
                      v-model="form.job.date_order"
                      value-format="yyyy-MM-dd HH:mm:ss">
            </fg-input>
          </div>
          <div class="col-6 mt-2">
            <fg-input :label="$t('job.create.details.premium')">
              <base-switch v-model="form.job.premium">
              </base-switch>
            </fg-input>
          </div>
        </div>
        <div class="col-12 flex">
          <div class="col-6">
            <fg-input :placeholder="$t('job.create.details.premiumDate')"
                      :label="$t('job.create.details.premiumDate')"
                      :name="$t('job.create.details.premiumDate')"
                      :add-form-control-class="false"
                      component="el-date-picker"
                      v-model="form.job.premium_till"
                      value-format="yyyy-MM-dd HH:mm:ss">
            </fg-input>
          </div>
          <div class="col-6">
            <fg-input v-model="form.job.boost_factor"
                      type="number"
                      :label="$t('job.create.details.premiumBoostFactor')">
              <small slot="infoBlock">
                {{$t('job.create.details.premiumBoostFactorTip')}}
              </small>
            </fg-input>
          </div>
        </div>
      </div>

    </div>

  </base-form>
</template>
<script>
  import Vue from 'vue'
  import cloneDeep from 'lodash/cloneDeep'
  import get from 'lodash/get'
  import { DatePicker, Select, Option } from 'element-ui'
  import { mapGetters, mapState, mapActions } from 'vuex';
  import JobService from 'src/services/JobService';
  import JobFollowers from '@/views/admin/jobs/JobDetails/JobFollowers'
  import JobCreateProduct from '../JobCreate/JobCreateProduct'
  import SegmentService from 'src/services/SegmentService';
  import JobCreateSegments from './../JobCreate/JobCreateSegments';
  import JobCreateDetails from "./../JobCreate/JobCreateDetails";
  import JobSelectJobBoards from "./../JobCreate/JobSelectJobBoards";
  import JobInfos from 'src/views/admin/organization/DataInfos'
  import { DAY } from 'src/config/dateUtils'
  import ClientService from 'src/services/ClientService'
  import entities from 'src/config/entities'

  Vue.use(DatePicker)
  export default {
    name: 'job-edit',
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      JobCreateDetails,
      JobCreateProduct,
      JobCreateSegments,
      JobSelectJobBoards,
      JobFollowers,
      JobInfos,
    },
    data() {
      return {
        form: {
          job: {},
          client: {},
          product: {},
        },
        renderKey: 1,
        formSaved: false,
        segmentsInfo: {},
        jobSegments: [],
        jobInfo: [],
        jobInfoEntity: entities.JOB_INFO,
        loading: false,
        activeTabIndex: 0,
        jobStatuses: ['active', 'pause', 'finished', 'draft', 'order']
      }
    },
    computed: {
      ...mapGetters('utils', ['isMobile']),
      ...mapGetters('config', ['jobPostingProducts', 'allProducts']),
      ...mapState({
        currentJob: state => state.jobs.currentJob,
      }),
      saveText() {
        if (this.currentJob.status === 'draft') {
          return this.$t('job.create.publish.title')
        }
        return this.$t('generic.save')
      }
    },
    methods: {
      ...mapActions('config', ['getConfig']),
      onProductSelect (product) {
        this.form.product = product
        this.form.job.product_id = product.product_id
        this.form.job.from = new Date()
        this.form.job.till = new Date(new Date().getTime() + product.job_days * DAY)
      },
      onJobBoardSelect (jobBoard) {
        this.form.job.job_board_id = get(jobBoard, 'id')
        console.log(this.form.job.job_board_id)
      },
      onSegmentsChange (segments) {
        this.jobSegments = segments
        this.updateSegmentKeys()
      },
      onPaymentSelected(payment) {
        this.form.payment = payment
        this.form.job.payment_type_id = payment.id
      },
      onContractsBalance(value) {
        this.contractsBalance = value
      },
      async onClientChange (client) {
        let selectedClient = client
        if (!client.uuid) {
          this.form.client = {
            name: client.name
          }
          // create the client
          let {data} = await ClientService.create(client)
          selectedClient = data
        }
        this.form.client = {
          ...selectedClient,
        }
        this.clientValid = client.name !== ''
        this.form.job.client = this.form.client
      },
      onPoNumberChange(value) {
        this.form.job.po_number = value
      },
      syncJob(newJob) {
        this.form.job = {
          ...newJob,
          job_board_id: this.form.job.job_board_id,
          ...this.getExtraSettingsFields()
        };
      },
      syncSegments(data) {
        let { segments, hours_min, hours_max, salary_type, salary_min, salary_max } = data
        this.form.job = {
          ...this.form.job,
          segments,
          hours_min,
          hours_max,
          salary_type,
          salary_min,
          salary_max,
          ...this.getExtraSettingsFields()
        }
      },
      getExtraSettingsFields() {
        let { premium, boost_factor, premium_till, status, date_order } = this.form.job
        return { premium, boost_factor, premium_till, status, date_order }
      },
      async validateSteps() {
        let steps = ['step0', 'step1', 'step2', 'step3']
        let promises = steps.map(step => {
          let stepRef = this.$refs[step];
          if (stepRef && stepRef.validate) {
            return stepRef.validate();
          }
          return Promise.resolve(true)
        })
        let responses = await Promise.all(promises)
        return responses.every(response => response)
      },
      async updateJob() {
        try {
          let valid = await this.validateSteps()
          if (!valid) {
            return
          }
          this.loading = true
          let job = this.form.job;
          if (this.currentJob.status === 'draft') {
            try {
              job.payment_type_id = get(this.form.payment, 'id')
              await JobService.publishDraftJob(job.uuid, job);
              this.$notify({type: 'success', message: this.$t('job.create.draft.success')})
              await this.getJobDetails()
              this.renderKey++
            } catch (err) {
              this.$notify({type: 'danger', message: this.$t('job.create.draft.error')})
            }
          } else {
            await JobService.update(job.uuid, job);
          }
          let jobBoardIds = this.form.job.job_boards.map(j => j.id);
          await JobService.updateJobBoards(job.uuid, {
            job_boards: jobBoardIds
          });
          this.$store.commit('jobs/SET_CURRENT_JOB', job);
          this.formSaved = true
        } finally {
          this.loading = false
        }
      },
      async getSegmentGroups (jobBoards) {
        let jobBoardIds = jobBoards.map(j => j.id)
        let {data} = await SegmentService.getJobBoardSegments({job_boards: jobBoardIds})
        this.jobSegments = data;
        this.updateSegmentKeys()
      },
      updateSegmentKeys() {
        if (!this.jobSegments) {
          return
        }
        this.jobSegments.forEach(segment => {
          if (!this.form.job.segments[segment.slug]) {
            this.$set(this.form.job.segments, segment.slug, [])
          }
        })
      },
      async handleJobChange(value) {
        value.segments = {
          function_category:[],
          industry:[],
          career_level:[],
          education:[],
          contract:[],
          time:[],
          ...value.segments
        }
        this.form.job = cloneDeep(value);
        if(this.form.job.remote === null) {
          this.form.job.remote = false;
        }
        this.jobInfo = this.form.job.info || []
        await this.getSegmentGroups(value.job_boards);
      },
      async getJobDetails() {
        let res = await JobService.getById(this.$route.params.id)
        let job = res.data
        if (!job) {
          return
        }
        this.$store.commit('jobs/SET_CURRENT_JOB', job)
      }
    },
    async beforeRouteLeave(to, from, next) {
      if (this.formSaved) {
        return next()
      }
      try {
        let result = confirm(this.$t('job.create.saveConfirm'))
        next(result)
      } catch (e) {
        next(false)
      }
    },
    async created() {
      await this.getConfig();
      this.$watch('currentJob', this.handleJobChange, { immediate: true })
    }
  }
</script>
<style>
</style>
